var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.title ? _c("label", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input-group" },
      [
        _c("vSelect", {
          attrs: {
            placeholder: _vm.placeholder,
            options: _vm.options,
            disabled: _vm.disabled,
            multiple: _vm.multiple,
            clearable: _vm.clearable,
            reduce: (option) => option[_vm.trackBy],
          },
          on: { input: _vm.emitInput },
          scopedSlots: _vm._u([
            {
              key: "no-options",
              fn: function () {
                return [_vm._v("No se encontraron opciones")]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.selectedValue,
            callback: function ($$v) {
              _vm.selectedValue = $$v
            },
            expression: "selectedValue",
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "invalid-feedback",
            class: { "d-block": _vm.hasErrors },
            attrs: { role: "alert" },
          },
          [_c("strong", [_vm._v(_vm._s(_vm.errors[0]))])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }